import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

class DatePickerInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth
    };

    this.onChange = this.onChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  onChange(date) {
    const { onChange } = this.props.input;
    onChange && onChange(date.format('YYYY-MM-DD'));
  }

  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  render() {
    const {
      input,
      label,
      placeholder,
      showYearDropdown,
      meta: { touched, error }
    } = this.props;
    const { windowWidth } = this.state;
    const dateValue = input.value ? moment(input.value, 'YYYY-MM-DD') : null;

    const mobileSize = (windowWidth < 450);
    const mobileView = (
      <input
        className="form-control"
        {...input}
        type="date"
        placeholder={placeholder}
      />
    );
    const webView = (
      <DatePicker
        className="form-control date-picker"
        locale="es"
        showYearDropdown={showYearDropdown}
        selected={dateValue}
        placeholderText={placeholder}
        onChange={this.onChange}
        onBlur={() => input.onBlur(input.value)}
      />
    );

    return (
      <div className={`form-group ${(touched && error) ? 'has-error' : ''}`}>
        {label && <label className="input-label" htmlFor={input.name}>{label}</label>}
        <div>
          {mobileSize ? mobileView : webView}
          {touched && error && <span className="error-message">{error}</span>}
        </div>
      </div>
    );
  }
}

const { string, bool, object } = PropTypes;

DatePickerInput.propTypes = {
  input: object.isRequired,
  label: string,
  placeholder: string,
  showYearDropdown: bool,
  meta: object
};

export default DatePickerInput;



// WEBPACK FOOTER //
// ./src/components/common/DatePickerInput.js